import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import FilterJackpotPrizeReportSportBet from "jet-views/regulations/jackpotPrizeReportSportBet/filterJackpotPrizeReportSportBet"; // Importing filter component
import TableJackpotPrizeReportSportBet from "jet-views/regulations/jackpotPrizeReportSportBet/tableJackpotPrizeReportSportBet"; // Importing table component

/**
 * Class representing the Jackpot Prize Report Casino View.
 * @extends JetView
 */
export default class JackpotPrizeReportCasinoView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization service
        const theme = this.app.config.theme; // Theme configuration
        let vthis = this; // Reference to the current instance

        // Toolbar configuration
        const toolbar = {
            id: "toolbar",
            view: "toolbar",
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: "select", // Dropdown for selecting page size
                    options: ["10", "20", "50", "100"],
                    width: 70,
                    on: {
                        onChange: function() { // Event handler for page size change
                            $$("datatable").getPager().config.size = this.getValue() * 1; // Update pager size
                            $$("datatable").refresh(); // Refresh the datatable
                            $$('datatable').scrollTo(100, 0); // Scroll to the top
                            vthis.app.callEvent("changeSize", [{}]); // Trigger change size event
                        }
                    }
                },
                {
                    id: "pagerA", // Pager component
                    view: "pager",
                    template: "{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}",
                    autosize: false,
                    height: 35,
                },
                {
                    id: "Export", // Export dropdown
                    view: "richselect",
                    name: "Export",
                    width: 120,
                    placeholder: _("Exportar"), // Placeholder for export
                    options: [
                        {id: "1", value: "Excel"} // Export option for Excel
                    ],
                    on: {
                        "onChange": function(value) { // Event handler for export selection
                            if (value == 1) { // Check if Excel is selected
                                let table = $$("datatable"); // Get the datatable
                                for (let j = 0; j < table.config.columns.length; j++) { // Iterate through columns
                                    if (table.config.columns[j].exportType) { // Check for export type
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent("export:data", [ // Trigger export event
                                    {
                                        NameReport: ($$("datatable").count() > 0 ? "" : _("No hay datos - ")) + _("Informe Del Premio Mayor (Deportivas)"),
                                        TypeReport: "Excel"
                                    }
                                ]);
                                webix.toExcel(table, { // Export to Excel
                                    filename: "Virtualsoft - " + new Date().toLocaleString("en-GB", {hour12: true}).replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1').replace(/[\/:]/g, '_').toUpperCase() + " - " + ($$("datatable").count() > 0 ? "" : _("No hay datos - ")) + _("Informe Del Premio Mayor (Deportivas)")
                                });
                            }
                            $$("Export").setValue(""); // Reset export selection
                        }.bind(this)
                    }
                }
            ]
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id: "a5",
            type: "clean",
            view: "form",
            scroll: "y",
            rows: [
                {
                    responsive: "a5",
                    type: "wide",
                    cols: [
                        {
                            css: "int-left",
                            rows: [
                                {
                                    view: "toolbar", // Toolbar for the report
                                    css: theme,
                                    elements: [
                                        {
                                            view: "label",
                                            label: _("Informe Del Premio Mayor - Deportivas (8.7.6)") // Report title
                                        },
                                        {
                                            id: "button-search", // Search button
                                            type: "wide",
                                            css: "close-bottom",
                                            cols: [
                                                {
                                                    view: "icon",
                                                    icon: "wxi-search", // Search icon
                                                    bottom: 20,
                                                    right: 35,
                                                    width: 30,
                                                    height: 30,
                                                    click: () => { // Click event to show filter popup
                                                        $$("filterPopup").show();
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            type: "wide",
                                            css: "close-bottom",
                                            cols: [
                                                {
                                                    view: "icon",
                                                    icon: "wxi-close", // Close icon
                                                    bottom: 20,
                                                    right: 35,
                                                    width: 30,
                                                    height: 30,
                                                    click: () => this.show("/top/dashboard") // Click event to navigate to dashboard
                                                }
                                            ]
                                        },
                                    ]
                                },
                                FilterJackpotPrizeReportSportBet, // Filter component
                                TableJackpotPrizeReportSportBet, // Table component
                                toolbar // Toolbar configuration
                            ]
                        }
                    ]
                }
            ]
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500 || screen.height < 500) { // Check screen size for toolbar visibility
                $$("toolbar").hide(); // Hide toolbar on small screens
            }
            if (screen.width > 500 && screen.height > 500) { // Check screen size for search button visibility
                $$("button-search").hide(); // Hide search button on larger screens
            }
        });
    }
}

// FILE DOCUMENTED
